import * as Yup from 'yup';

const serviceSchema = Yup.lazy((service) => {
  if (service?._destroy) return Yup.object().shape({ _destroy: Yup.boolean() });

  return Yup.object().shape({
    name: Yup.string()
      .trim()
      .required('Service name is required')
      .max(100, 'Maximum 100 characters'),
    description: Yup.string()
      .trim()
      .required('Service description is required')
      .max(500, 'Maximum 500 characters'),
  });
});

const optionalUrl = (message) =>
  Yup.string().trim().url(message).nullable();

const STEP_SCHEMAS = {
  about_you: Yup.object().shape({
    avatarUrl: Yup.string().required('Profile picture is required'),
    city: Yup.mixed().required('City is required'),
    industry_since: Yup.mixed().required('Industry start year is required'),
    member_types: Yup.array()
      .min(1, 'Choose at least one member type')
      .max(3, 'Choose up to 3 member types'),
    biography: Yup.string().trim().max(500, 'Maximum 500 characters'),
    languages: Yup.array(),
  }),
  work: Yup.object().shape({
    users_services: Yup.array()
      .of(serviceSchema)
      .test(
        'at-least-one-active-service',
        'Add at least one service',
        (services) => services?.some((service) => !service?._destroy)
      ),
    industry_areas: Yup.array()
      .min(1, 'Choose at least one industry area')
      .max(3, 'Choose up to 3 industry areas'),
    professional_goals: Yup.array()
      .min(1, 'Choose at least one goal')
      .max(3, 'Choose up to 3 goals'),
    target_markets: Yup.array()
      .min(1, 'Choose at least one target market')
      .max(5, 'Choose up to 5 target markets'),
    professional_skills: Yup.array(),
    professional_roles: Yup.array().max(3, 'Choose up to 3 creative roles'),
    interest_topics: Yup.array().max(5, 'Choose up to 5 genres'),
    rep_artists: Yup.array(),
    rep_events: Yup.array(),
    rep_venues: Yup.array(),
  }),
  connect: Yup.object().shape({
    facebook: optionalUrl('Enter a valid Facebook URL'),
    linked_in: optionalUrl('Enter a valid LinkedIn URL'),
    instagram: optionalUrl('Enter a valid Instagram URL'),
    spotify_playlists: Yup.array().of(
      optionalUrl('Enter a valid Spotify URL')
    ),
    youtube_playlists: Yup.array().of(
      optionalUrl('Enter a valid YouTube URL')
    ),
    music_genres: Yup.array(),
    event_types: Yup.array().max(
      3,
      'Choose up to 3 event types'
    ),
    event_formats: Yup.array(),
    event_attend_locations: Yup.array(),
  }),
};

export default STEP_SCHEMAS;
